export const demo = [
  {
    name: 'Person',
    file: 'sample.json'
  },
  {
    name: 'Place',
    file: 'sample_place.json'
  },
  {
    name: 'Recipe',
    file: 'sample_recipe.json'
  },
  {
    name: 'DataCite',
    file: 'datacite.json'
  },
  {
    name: 'BioSample',
    file: 'biosample.json'
  }
]



// WEBPACK FOOTER //
// ./src/demo.js